import { useEffect } from 'react';
import './PrivacyPolicy.scss';
import { scrollTop } from '../../helpers/scrollTop';

export const PrivacyPolicyRS = () => {
  useEffect(() => {
    scrollTop();
  });
  return (
    <section className="policy">
      <div className="_container policy__container">
        <h1 className="policy__title title">Politika Privatnosti</h1>
        <div>
          <p>
            <em>
              Shodno odredbi člana 23 Zakona o zaštiti podataka o ličnosti
              (&quot;Sl. glasnik RS&quot;, br. 87/2018, u daljem tekstu:
              &quot;Zakon&quot;) i shodno Opštoj uredbi o zaštiti podataka br.
              2016/679, dalje: („GDPR“)Rukovalac SIXTIX D.O.O Beograd, matični
              broj:21940291, PIB:113886255, čiji je zakonski zastupnik Jelle
              Richard De Boer, direktor, (dalje: &quot;Rukovalac&quot;), izdaje
              sledeće:
            </em>
          </p>
          <br />

          <p>
            <strong>OBAVEŠTENJE O OBRADI PODATAKA O LIČNOSTI</strong>
          </p>
          <p>
            <strong>(&quot;Obaveštenje&quot;)</strong>
          </p>
          <p>
            <em>
              Svrha ovog Obaveštenja je da Rukovalac, osigura ostvarivanje i
              zaštitu prava na privatnost lica koja su izvršila kupovinu
              ulaznica za različite događaje kod Rukovaoca dalje:
              (“kupci/korisnici”), kao i da ih informiše o njihovim pravima u
              vezi sa obradom podataka o ličnosti.
            </em>
          </p>
          <p>
            <strong>Podaci o ličnosti koji se obrađuju</strong>
          </p>
          <p>
            ime, prezime, adresa isporuke, broj telefona i Vaša e-mail adresa.
          </p>
          <p>
            <strong>
              Svrha nameravane obrade podataka i pravni osnov za obradu podataka
            </strong>
          </p>
          <p>
            Podaci se obrađuju u svrhu zaključenja i izvršenja ugovora o prodaji
            ulaznica za različite događaje, kao i u svrhu slanja obaveštenja o
            tim događajima (npr. promena termina održavanja, otkazivanje i sl.)
          </p>
          <p>
            Pravni osnov obrade jeste:obrada je neophodna za izvršenje ugovora
            zaključenog sa licem na koje se podaci odnose ili za preduzimanje
            radnji, na zahtev lica na koje se podaci odnose, pre zaključenja
            ugovora.
          </p>
          <p>
            Davanje podataka o ličnosti kao ugovorna obaveza i neophodan uslov
            za zaključenje ugovora
          </p>
          <p>
            Predmetni podaci predstavljaju neophodan uslov za zaključenje
            ugovora o kupovini ulaznica za određeni događaj.
          </p>
          <p>
            <strong>Obrađivač podataka</strong>
          </p>
          <ul>
            <li>Privredno društvo SendGrid, SAD</li>
            <li>Privredno društvo Seats.io, KraljevinaBelgija</li>
            <li>Privredno društvo DigitalOcean Netherlands B.V. , Holandija</li>
          </ul>
          <p>
            <strong>
              Iznošenje podataka o ličnosti u drugu državu ili međunarodnu
              organizaciju
            </strong>
          </p>
          <p>Podaci se iznose u Kraljevinu Belgiju i SAD i Holandiju.</p>
          <p>
            <strong>Primaoci evidencije</strong>
          </p>
          <p>/</p>
          <p>
            <strong>
              Rok čuvanja podataka i kriterijum za njegovo određivanje
            </strong>
          </p>
          <p>Podaci se čuvaju najviše 10 godina.</p>
          <p>
            <strong>Prava lica čiji se podaci o ličnosti obrađuju</strong>
          </p>
          <p>
            Lice ima pravo pristupa, pravo na ispravku, dopunu, brisanje,
            ograničenje i prenosivost podataka, kao i pravo na prigovor i
            automatizovano donošenje pojedinačnih odluka.
          </p>
          <p>
            Lice ima pravo na opoziv pristanka u bilo koje vreme, pri čemu
            opoziv pristanka ne utiče na dopuštenost obrade pre opoziva.
          </p>
          <p>
            U slučaju opoziva pristanka, Rukovalac neće obrađivati podatke Lica
            na koje se opoziv odnosi, osim ukoliko Rukovalac ima zakonsko
            ovlašćenje za obradu.
          </p>
          <p>
            Navedene zahteve Lica dostavljaju e-mailom na e-mail adresu{' '}
            <a className="policy__link-rs" href="mailto:info@sixtix.com">
              info@sixtix.com
            </a>
            .
          </p>
          <p>
            Rukovalac će na svaki zahtev odgovoriti u najkraćem mogućem roku, a
            u svakom slučaju najkasnije u roku od 30 dana od prijema zahteva u
            skladu sa članom 21 Zakona i članom 12 GDPR.
          </p>
          <p>
            Lice može podneti pritužbu u vezi sa obradom svojih podataka o
            ličnosti pred Poverenikom za informacije od javnog značaja i zaštitu
            podataka o ličnosti.
          </p>
          <p>
            <strong>
              Davanje podataka o ličnosti kao ugovorna obaveza i neophodan uslov
              za zaključenje ugovora Tehničke i organizacione mere radi zaštite
              podataka o ličnosti
            </strong>
          </p>
          <br />
          <p>
            Rukovalac i obrađivač su sproveli tehničke i organizacione mere
            zaštite radi sigurnosti i integriteta podataka o ličnosti, zaštite
            podataka od neovlašćenih pristupa, zlonamernih postupaka, gubitka
            ili otkrivanja podataka neovlašćenim trećim licima.
          </p>
          <p>
            Prihvatanjem ovog Obaveštenja Lice je svesno i saglasano da se
            njegovi podaci o ličnosti navedeni u ovom Obaveštenju, obrađuju od
            strane Rukovaoca i Obrađivača, kao i da navedenim podacima mogu
            pristupiti zaposlena i angažovana lica kod Rukovaoca i Obrađivača.
            Lica koja pristupaju podacima o ličnosti su obavezna da podatke
            čuvaju kao poverljive i na siguran način, a od njih se zahteva da
            koriste podatke o ličnosti samo u gore pomenute svrhe.
          </p>
          <p>
            <em>Rukovalac</em>
          </p>
          <br />
          <p>
            <strong>Politika privatnosti</strong>
          </p>
          <br />
          <p>
            <strong>SIXTIX D.O.O. Beograd</strong>
          </p>
          <p>Humska 1, Savksi Venac 11000 Beograd</p>
          <p>
            Delatnost i šifra delatnosti: 7990, Ostale usluge rezervacije i
            delatnosti povezane s njima
          </p>
          <p>Matični broj: 21940291</p>
          <p>PIB: 113886255</p>
          <p>
            Web adresa:{' '}
            <a className="policy__link-rs" href="https://www.sixtix.com">
              https://www.sixtix.com
            </a>
          </p>
          <br />
          <p>
            <strong>Kriptovane porudžbine</strong>
          </p>
          <p>
            Svi Vaši lični podaci će biti transferisani SSL (Secure Socket
            Layer) metodom u 128-bitnoj enkripciji (RSA s 1024bita) i zbog toga
            ne mogu biti iskorišćene od strane trećih osoba. Ovo je trenutno
            najnoviji standard sigurnosti na internetu.
          </p>
          <p>
            <strong>Sertifikat</strong>
          </p>
          <p>
            SIXTIX D.O.O. Beograd je sertifikovan od strane AlphaSSL (
            <a className="policy__link-rs" href="https://www.alphassl.com/">
              https://www.alphassl.com/
            </a>
            ). Ovlašćeni overilac sertifikata garantuje siguran prenos Vaših
            podataka i autentičnost našeg servera. reCAPTCHA zaštita Ovaj sajt
            je zaštićen sa reCAPTCHA zaštitom i primenjuje se Google{' '}
            <a
              className="policy__link-rs"
              href="https://policies.google.com/privacy"
            >
              Politika privatnosti
            </a>{' '}
            i{' '}
            <a
              className="policy__link-rs"
              href="https://policies.google.com/terms"
            >
              Uslovi servisa
            </a>
            .
          </p>
          <p>
            <strong>Cookies / kolačići</strong>
          </p>
          <p>
            Kolačići su alfanumerički paketi informacija sa varijabilnim
            sadržajem koje šalje veb server koji se čuvaju na računaru korisnika
            i čuvaju u unapred određenom roku važenja. Upotreba kolačića
            omogućava da se ispituju neki podaci posetioca veb stranice i da se
            prati njihovo korišćenje na internetu. Kolačići pomažu da se prate
            interesovanja korisnika, obrasci upotrebe interneta i istorija
            poseta veb stranici kako bi se osiguralo da je iskustvo kupovine
            korisnika optimalno. Budući da se kolačići koriste kao vrsta oznake
            koja omogućava veb stranici da prepozna posetioca koji se vraća na
            stranicu, pomoću njih se takođe mogu sačuvati važeće korisničko ime
            i lozinka za tu veb lokaciju. Ako pregledač pošalje prethodno
            sačuvani kolačić, provajder servisa koji obrađuje kolačić ima
            mogućnost povezivanja trenutne posete korisnika sa prethodnom, ali
            samo u vezi sa njihovim sopstvenim sadržajem.
          </p>
          <p>
            Informacije koje kolačići šalju olakšavaju prepoznavanje veb
            pretraživača, pa korisnici mogu primiti relevantan i
            „personalizovan“ sadržaj. Kolačići čine pregledavanje praktičnijim,
            uključujući potrebe za bezbednošću podataka na mreži i relevantno
            oglašavanje. Uz pomoć kolačića, provajder servisa takođe može
            kreirati anonimne statistike o navikama gledalaca stranica, tako da
            može bolje prilagoditi izgled i sadržaj stranice.
          </p>
          <p>
            <strong>
              Veb lokacija dobavljača usluge koristi dve vrste kolačića:
            </strong>
          </p>
          <ul>
            <li>
              Privremeni kolačići (obavezni)– kolačići za upotrebu sesije
              (session-id) neophodni za upotrebu veb stranice. Njihova upotreba
              je od suštinskog značaja za navigaciju i za funkcionisanje veb
              stranice. Bez njih, sajt ili njegovi delovi neće biti prikazani,
              pregledavanje postaje ometano, stavljanje ulaznica u korpu ili
              bankovno plaćanje ne mogu se pravilno sprovesti.
            </li>
            <li>
              Trajni kolačići (analitički i marketing/oglašavanje) - koji će
              ostati na uređaju, ovisno o podešavanjima veb pretraživača, dugo
              ili dok ih korisnik ne obriše. Unutar njih postoje interni i
              eksterni kolačići. Interni kolačići se stvaraju ako server
              provajdera servisa instalira kolačić i podaci se proslede u
              njegovu sopstvenu bazu podataka. Ako je kolačić instalirao server
              provajdera servisa, ali se podaci prosleđuju spoljnom provajderu,
              koristi se spoljni kolačić. Kolačići treće strane koje je treća
              strana postavila u pregledač korisnika (Google Analitics, Facebook
              Pixel) su spoljni kolačići. Oni se stavljaju u pretraživač ako
              posećena veb lokacija koristi usluge koje pruža treća strana.
              Svrha stalnih kolačića je da se osigura da veb lokacija
              funkcioniše na najvišem nivou u cilju povećanja korisničkog
              iskustva.
            </li>
            <li>
              Prilikom posete veb stranici Korisnik može dati svoju saglasnost
              za čuvanje trajnih kolačića sačuvanih na svom računaru kojima može
              pristupiti provajder servisa klikom na dugme upozorenja o
              kolačićima na stranici za prijavu.
            </li>
          </ul>
          <p>
            Korisnik može konfigurisati i sprečiti aktivnosti vezane za kolačiće
            pomoću programa pretraživača. Korišćenjem upravljanja kolačićima
            korisnik obično može koristiti kolačiće ili opciju praćenja kolačića
            u meniju Privatnost / Istorija / Prilagođena podešavanja u meniju
            Alati / Podešavanja. Međutim, imajte na umu da je bez upotrebe
            kolačića moguće da korisnik neće moći da koristi svaku uslugu koju
            nudi veb lokacija, a naročito opcije plaćanja.
          </p>
          <p>
            Svrha obrade podataka: obavljanje platnih transakcija s pružateljem
            platnih usluga, identifikacija i razlikovanje korisnika,
            identifikacija korisnikove trenutne sesije, čuvanje podataka
            stvorenih tokom sesije, sprečavanje gubitka podataka, identifikacija
            i praćenje korisnika, veb analitika.
          </p>
          <p>
            Obim obrađenih podataka: identifikacioni broj, datum, vreme i
            prethodno posećena veb stranica.
          </p>
          <p>
            Period obrade podataka: privremeni kolačići se čuvaju dok se ne
            zatvore sve veb lokacije iste vrste.
          </p>
          <p>
            Trajni kolačići se čuvaju na računaru korisnika godinu dana ili dok
            ih korisnik ne izbriše.
          </p>
          <p>
            Moguće posledice neuspeha u pružanju podataka: nedostupnost
            određenih servisa veb stranice, neuspešne platne transakcije,
            netačnosti u analitici.
          </p>
          <br />
          <p>
            <strong>E-Mail</strong>
          </p>
          <p>
            SIXTIX d.o.o. koristi vašu e-mail adresu samo za postupak
            poručivanja ulaznica, kao i dostavljanja važnih obaveštenja o
            dogadjajima za koji ste kupili ulaznicu (kao što su promena termina,
            otkazivanje događaja ili sl).
          </p>
          <p>
            SIXTIX d.o.o. će vam obaveštenja o važnim poboljšanjima naše web
            stranice / webshopa / postupka kupovine dostavljati isključivo uz
            prethodno pribavljenu vašu saglasnost.
          </p>
          <p>
            SIXTIX d.o.o. će oglasne poruke dostavljati isključivo uz prethodno
            pribavljenu vašu saglasnost.
          </p>
          <p>
            <strong>Ugovor</strong>
          </p>
          <p>
            Naš online servis podrazumeva sporazumno korišćenje i čuvanje Vaših
            podataka. Sve izmene u našem poslovanju koje se odnose na bezbednost
            i poverljivost podataka biće objavljene na našoj web stranici.
          </p>
          <p>
            <strong>Zaštita ličnih podataka</strong>
          </p>
          <p>
            <em>Registracija, prikupljanje i upotreba informacija</em>
          </p>
          <p>
            Tokom procesa kupovine / registracije skupljamo podatke kao što su
            ime, prezime, adresa isporuke, broj telefona i Vaša e-mail adresa. U
            slučaju kada se korisnik registruje putem Facebook ili Google
            naloga, ti podaci se koriste u skladu sa Facebook ili Google
            politikom privatnosti, sa kojom je korisnk saglasan. Vaše podatke
            koristićemo samo u svrhu izvršenja naše usluge i plaćanja. Ime,
            prezime i email adresa mogu biti ispisana na e-ulaznici kako bi se
            sprečila moguća zloupotreba.
          </p>
          <p>
            Pri procesu refundacije imamo pravo da zatražimo podatke vašeg
            tekućeg računa, koje ćemo čuvati u skladu sa Politikom privatnosti i
            koristiti isključivo za potrebe povraćaja sredstava. Ovi podaci će
            biti zaštićeni odgovarajućim sigurnosnim protokolima i neće biti
            dostupni trećim licima osim kada je to zakonski obavezno.
          </p>
          <p>
            Da biste primali naš newsletter, potrebna nam je Vaša e-mail adresa.
            Da biste dobili vesti, potrebno je da se prijavite na naš newsletter
            i potvrdite da ste saglasni da vam isti bude dostavljen putem
            mail-a. Poštujući Vašu privatnost, omogućili smo vam da se u svakom
            trenutku sami odjavite sa ove liste. Pogledajte odeljak
            &quot;Unsubsrcibe&quot; ovog dokumenta. SIXTIX d.o.o. je ekskluzivni
            vlasnik podataka prikupljenih na web sajtu www.sixtix.com.
          </p>
          <br />
          <p>
            <em>Svrha nameravane obrade podataka</em>
          </p>
          <p>
            <strong>
              Svrha obrade podataka jeste izvršavanje ugovornih obaveza u vezi
              sa kupovinom ulaznica za različite događaje.
            </strong>
          </p>
          <br />
          <p>
            <em>Pravni osnov obrade podataka</em>
          </p>
          <p>
            Pravni osnov obrade jeste: obrada je neophodna za izvršenje ugovora
            zaključenog sa licem na koje se podaci odnose ili za preduzimanje
            radnji, na zahtev lica na koje se podaci odnose, pre zaključenja
            ugovora.
          </p>
          <p>
            Davanje podataka o ličnosti kao ugovorna obaveza i neophodan uslov
            za zaključenje ugovora
          </p>
          <p>
            Predmetni podaci predstavljaju neophodan uslov za zaključenje
            ugovora o kupovini ulaznica za određeni događaj.
          </p>
          <br />
          <p>
            <em>
              Iznošenje podataka u drugu državu ili međunarodnu organizaciju:
            </em>
          </p>
          <p>Podaci se iznose u Belgiju, SAD i Holandiju.</p>
          <br />
          <p>
            <em>Rok čuvanja podataka:</em>
          </p>
          <p>Podaci se čuvaju 10 godina.</p>
          <br />
          <p>
            <em>Narudžbine</em>
          </p>
          <p>
            Morate uneti podatke o kontaktu (kao što su Vaše ime, adresa
            e-pošte, broj telefona i adresa) i informacije o plaćanju (kao što
            su broj platne kartice, datum roka i ime platne kartice ako se
            odlučite da platite platnom karticom). SIXTIX d.o.o. nema uvid o
            podacima vezanim za platnu karticu, već se proces unosa tih podataka
            vrši na platformi provajdera plaćanja.
          </p>
          <p>
            Mi ćemo koristiti ove informacije za izdavanje fakture i ispunjenje
            Vašeg naloga. U zavisnosti od ličnih podataka koje pružate, biće vam
            poslata faktura sa identifikacionim brojem kupovine i svim ostalim
            potrebnim informacijama. Ako dođe do problema pri popunjavanju Vašeg
            naloga, koristićemo te informacije da Vas kontaktiramo.
          </p>
          <br />
          <p>
            <em>Odnosi s kupcima</em>
          </p>
          <p>
            Lične informacije koje unesete će nam pomoći da stupimo u kontakt sa
            Vama, odgovorimo na Vaša pitanja, pružimo usluge koje ste izabrali i
            upravljate nalogom. Ako je potrebno, kontaktiraćemo Vas putem
            e-maila ili telefona.
          </p>
          <br />
          <p>
            <em>Profil</em>
          </p>
          <p>
            Sakupljamo informacije koje primamo putem kolačića i datoteka
            dnevnika, ali mi ne stvaramo nikakav &quot;profil&quot; Vaših
            preferencija. Povezaćemo Vaše lične podatke sa Vašim kupovinama, ali
            ih nećemo deliti sa trećim licima.
          </p>
          <br />
          <p>
            <em>Korišćenje i objavljivanje podataka</em>
          </p>
          <p>
            Vaše lične podatke ponekad delimo trećoj strani i pružaocima usluga.
            Treće strane, koristimo za pružanje usluga dostave kao i za proces
            plaćanja kreditnom karticom preko naše web stranice. Ove kompanije
            lične podatke čuvaju i koriste po svojim pravilima o zaštiti
            podataka.
          </p>
          <p>
            U slučaju da bilo koja treća strana koja nije naš agent ili pružalac
            usluga, traži informacije, bićete obavešteni, a Vi ćete imati
            mogućnost da odlučite da li želite da date svoje lične podatke ovom
            klijentu.
          </p>
          <br />
          <p>
            SIXTIX d.o.o. radi u ime i za račun Organizatora manifestacije.
            Ukoliko se za događaj Organizatora manifestacije ustanovi da je u
            pitanju događaj visokog rizika (najčešće sportske manifestacije)
            Zakon o sprečavanju nasilja i nedoličnog ponašanja na sportskim i
            ostalim priredbama nalaže SIXTIX– u da deluje u skladu sa Zakonom,
            te prikuplja lične podatke kupaca(npr. JMBG) i predaje direktno
            Organizatoru. Banka prihvatilac plaćanja ne učestvuje u prikupljanju
            ovih ličnih podataka (npr. JMBG), niti se bavi obradom ovih
            podataka, te se svi podaci isključivo distribuiraju Organizatoru
            manifestacije.
          </p>
          <br />
          <p>
            <em>Odricanje</em>
          </p>
          <p>
            Zadržavamo pravo otkrivanja Vaših ličnih podataka ako to zahteva
            zakon i ako verujemo da je obelodanjivanje neophodno za zaštitu
            naših prava i / ili za postupanje u skladu sa sudskom istragom,
            sudskim nalogom ili pravnim postupkom.
          </p>
          <br />
          <p>
            <em>Datoteke dnevnika</em>
          </p>
          <p>
            U skladu sa pravilima većine web lokacija, automatski prikupljamo
            određene informacije i čuvamo ih u log fajlovima. Ove informacije
            uključuju Internet protokol (IP) adrese, tip pretraživača, Internet
            Service Provider (ISP) stranica sa kojih ste pristupili sajtu i
            stranicu na koju se ide iz našeg sistema, datum i vreme pristupa, i
            tok podataka po kliku.
          </p>
          <p>
            Ova informacija, koja ne identifikuje pojedinačne korisnike, se
            koristi za analizu trendova, administraciju sajta, praćenje
            korisničkog kretanja i prikupljanje demografskih podataka o našim
            korisnicima uopšte.
          </p>
          <p>Ne povezujemo ove podatke sa ličnim podacima.</p>
          <br />
          <p>
            <em>Linkovi na druge stranice</em>
          </p>
          <p>
            Ova stranica sadrži linkove na web lokacije koje nisu u vlasništvu
            ili kontrolisane od strane SIXTIX d.o.o. Nismo odgovorni za politiku
            privatnosti ovih stranica. Preporučujemo da pročitate politiku
            privatnosti za svaku lokaciju koja prikuplja lične podatke i da
            budete pažljivi kada napustite našu web lokaciju. Naša politika
            privatnosti se odnosi samo na informacije koje sakupljamo na ovoj
            web lokaciji.
          </p>
          <br />
          <p>
            <em>Pristup ličnim informacijama</em>
          </p>
          <p>
            Ako se Vaše lične informacije menjaju, možete ih ispraviti ili
            ažurirati unošenjem promena na vašim profilima (u zavisnosti od
            klijenta I za koju manifestaciju ste se prijavili) ili putem e-maila{' '}
            <a className="policy__link-rs" href="mailto:info@sixtix.com">
              info@sixtix.com
            </a>{' '}
            .
          </p>
          <br />
          <p>
            <em>Sigurnost</em>
          </p>
          <p>
            Sigurnost Vaših ličnih podataka je važna za nas. Svi Vaši lični
            podaci će biti transferisani SSL (Secure Socket Layer) metodom u
            128-bitnoj enkripciji (RSA s 1024bita) i zbog toga ne mogu biti
            iskorišćene od strane trećih osoba. Ovo je trenutno najnoviji
            standard sigurnosti na internetu. SIXTIX d.o.o. je sertifikovan od
            strane AlphaSSL (
            <a className="policy__link-rs" href="https://www.alphassl.com/">
              https://www.alphassl.com
            </a>
            ). Ovlašćeni overilac sertifikata garantuje siguran prenos Vaših
            podataka i autentičnost našeg servera.
          </p>
          <p>
            Za zaštitu Vaših ličnih podataka koristimo industrijski prihvaćene
            standarde, kako tokom samog prenosa tako i kada dođu do nas.
            Međutim, nikakav način slanja podataka preko Interneta ili
            elektronskog skladišta nije 100% siguran. Stoga, uprkos upotrebi
            opšte prihvaćenih standarda i metoda zaštite Vaših ličnih podataka,
            ne možemo garantovati njihovu apsolutnu sigurnost. Da biste saznali
            više o bezbednosti na našem sajtu možete nam poslati e-mail na{' '}
            <a className="policy__link-rs" href="mailto:info@sixtix.com">
              info@sixtix.com
            </a>{' '}
            ili na broj telefona +381 69 8017686
          </p>
          <br />
          <p>
            <em>Promena u poslovanju</em>
          </p>
          <p>
            Ako SIXTIX d.o.o. prolazi kroz poslovne promene, kao što su
            spajanja, sticanja druge kompanije ili prodaje veći deo svoje
            imovine Vaši lični podaci će verovatno biti deo prodate imovine.
            Bićete obavešteni o bilo kakvoj većoj promeni vlasništva ili
            kontroli Vaših ličnih podataka putem e-pošte ili putem hitnog
            obaveštenja na našoj web lokaciji 30 dana pre promene.
          </p>
          <br />
          <p>
            <em>Izmene Izjave o privatnosti</em>
          </p>
          <p>
            Ako odlučimo da promenimo našu politiku privatnosti, objavićemo ove
            izmene na našoj web lokaciji i na drugim sajtovima za koje smatramo
            da su prikladni. Ovo će vam pomoći da znate kako se sakupljaju i
            koriste podaci, kao i okolnosti pod kojima se mogu otkriti.
          </p>
          <p>
            Zadržavamo pravo izmene ove Izjave o privatnosti, tako da je redovno
            proveravate. Ovde ćete biti obavešteni o promenama naše politike
            privatnosti, ili putem e-pošte ili putem obaveštenja na našoj web
            stranici.
          </p>
          <br />
          <p>
            <em>Prava lica čiji se podaci obrađuju</em>
          </p>
          <p>
            Lice ima pravo pristupa, pravo na ispravku, dopunu, brisanje,
            ograničenje i prenosivost podataka, kao i pravo na prigovor i
            automatizovano donošenje pojedinačnih odluka.
          </p>
          <p>
            Lice ima pravo na opoziv pristanka u bilo koje vreme, pri čemu
            opoziv pristanka ne utiče na dopuštenost obrade pre opoziva.
          </p>
          <p>
            U slučaju opoziva pristanka, Rukovalac neće obrađivati podatke Lica
            na koje se opoziv odnosi, osim ukoliko Rukovalac ima zakonsko
            ovlašćenje za obradu.
          </p>
          <p>
            Navedene zahteve Lica dostavljaju e-mailom na e- mail adresu{'  '}
            <a className="policy__link-rs" href="mailto:info@sixtix.com">
              info@sixtix.com
            </a>{' '}
            .
          </p>
          <p>
            Rukovalac će na svaki zahtev odgovoriti u najkraćem mogućem roku, a
            u svakom slučaju najkasnije u roku od 30 dana od prijema zahteva u
            skladu sa članom 21 Zakona i članom 12 GDPR.
          </p>
          <p>
            Lice može podneti pritužbu u vezi sa obradom svojih podataka o
            ličnosti pred Poverenikom za informacije od javnog značaja i zaštitu
            podataka o ličnosti.
          </p>
          <br />
          <p>
            <strong>Kontaktirajte nas</strong>
          </p>
          <p>
            Ako imate pitanja ili sugestije u vezi sa našom politikom
            privatnosti, možete nam poslati e-mail na{' '}
            <a className="policy__link-rs" href="mailto:info@sixtix.com">
              info@sixtix.com
            </a>{' '}
            ili pozivom na broj telefona +381 69 8017686
          </p>
        </div>
      </div>
    </section>
  );
};
